<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { $bus } from '@/common/events'
import { $router } from '@/router'
import { useMenu } from '@/composables/menu'
import { useCabinetAlarm } from '@/composables/alarm'
import { useMaintenance } from '@/composables/maintenance'
import { useSystemStatus } from '@/composables/system'

const { isServiceMode } = useSystemStatus();

const props = defineProps({
  allowSkip: {
    type: Boolean,
    default: false
  }
});

function goToLogin() {
  $router.push({ name: "Login" });
}

function goToManualControl() {
  useCabinetAlarm(false);
  useMaintenance(false);
  useMenu({ service: true });
  $router.push({ name: "ServiceWindow", query: { service: "true" } });
}
</script>

<template>
  <!-- Service mode notice -->
  <div class="service-mode-panel" v-if="isServiceMode">
    <div class="grid place-items-center">
      <h1 class="text-xl font-medium">Servisni način</h1>
    </div>
    <div class="flex gap-2">
      <Button type="primary" class="h-12" @click="goToManualControl()"><i class="fa fa-gear mr-2"></i>Ročno upravljanje</Button>
      <Button type="primary" class="h-12" @click="goToLogin()" v-if="props.allowSkip">Preskoči<i class="fa fa-arrow-right ml-2"></i></Button>
    </div>
  </div>
</template>

<style scoped>
.service-mode-panel {
  @apply fixed flex flex-row justify-between left-0 top-0 px-5 py-5 w-full bg-amber-300;
}

.service-mode-panel {
  background-color: #fde68a;
  background-image: url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23fcd34d' fill-opacity='0.4' fill-rule='evenodd'%3E%3Cpath d='M0 40L40 0H20L0 20M40 40V20L20 40'/%3E%3C/g%3E%3C/svg%3E");
}
</style>
